export class Visit {
  constructor(data) {
    this.id = data.id; // string
    /* The recorded GPS track: a list of coordinates, written only by the mobile app. Present only
       on the single-visit endpoint (`VisitDetailSerializer`) — every other visit serializer
       excludes it, so it is absent from list rows and from a visit nested in an answer. */
    this.meta = data.meta;
    this.point = data.point; // object
    this.start = data.start; // string
    this.end = data.end; // string
    this.user = data.user;
  }
}
